import { apiPost } from './client';
import type { RetrievalDiagnostics } from '@/types/answer';

export interface PreviewRequest {
  principal_id: string;
  connector_id: string;
  query: string;
  top_k?: number;
  search_mode?: string;
  alpha?: number;
}

export interface PreviewResult {
  vector_id: string;
  resource_title: string | null;
  score: number;
  content_preview: string | null;
  classification: string | null;
  domain: string | null;
}

export interface DeniedResult {
  vector_id: string;
  resource_title: string | null;
  score: number;
  denial_reasons: string[];
  classification: string | null;
  domain: string | null;
}

export interface PreviewResponse {
  outcome: string;
  query: string;
  principal_name: string;
  connector_name: string;
  search_mode: string;
  total_results: number;
  allowed_results: PreviewResult[];
  denied_results: DeniedResult[];
  policy_trace: { policy_id: string; policy_name: string; effect: string }[];
  timing_ms: number;
  diagnostics?: RetrievalDiagnostics | null;
}

export function runPreview(data: PreviewRequest): Promise<PreviewResponse> {
  return apiPost<PreviewResponse>('/simulator/preview', data);
}

export function runBatchPreview(data: {
  principal_ids: string[];
  connector_id: string;
  query: string;
  top_k?: number;
  search_mode?: string;
  alpha?: number;
}): Promise<{ data: PreviewResponse[] }> {
  return apiPost<{ data: PreviewResponse[] }>('/simulator/preview-batch', data);
}
